import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, Printer, Minus, Plus, Download } from "lucide-react";
import { colors, type, spacing, radius } from "@/theme";
import { api } from "@/lib/api";
import { useRequireAuth } from "@/lib/useRequireAuth";

export default function AdminQr() {
  const navigate = useNavigate();
  const { user } = useRequireAuth();
  const [copies, setCopies] = useState(30);
  if (!user) return null;

  const open = () => window.open(api.qrPdfUrl(copies), "_blank", "noopener");

  return (
    <div style={{ minHeight: "100vh", background: colors.bg }}>
      <div style={{ maxWidth: 560, margin: "0 auto" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: `${spacing.md}px ${spacing.lg}px` }}>
          <button data-testid="back-button" onClick={() => navigate(-1)} style={plain}><ChevronLeft size={26} color={colors.ink} /></button>
          <div style={{ ...type.serif, fontSize: 22, color: colors.ink }}>QR da stampare</div>
          <div style={{ width: 26 }} />
        </div>
        <div style={{ padding: spacing.lg, display: "flex", flexDirection: "column", alignItems: "center", gap: spacing.md, marginTop: spacing.xl }}>
          <div style={{ width: 88, height: 88, borderRadius: 44, background: colors.accentSoft, display: "flex", alignItems: "center", justifyContent: "center" }}><Printer size={40} color={colors.accent} /></div>
          <div style={{ ...type.serif, fontSize: 24, color: colors.ink, textAlign: "center" }}>Un solo QR per il locale</div>
          <div style={{ ...type.sans, fontSize: 15, color: colors.inkSoft, textAlign: "center", lineHeight: "22px" }}>Il QR porta direttamente al tuo menu. Il cliente inquadra, digita il tavolo e ordina. Stampa una copia per tavolo, 4 per foglio A4.</div>
          <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between", background: colors.surface, borderRadius: radius.lg, padding: spacing.md, border: `1px solid ${colors.line}`, marginTop: spacing.md }}>
            <span style={{ ...type.sansSemi, fontSize: 16, color: colors.ink }}>Copie</span>
            <div style={{ display: "flex", alignItems: "center", gap: spacing.sm }}>
              <button data-testid="copies-minus" onClick={() => setCopies((c) => Math.max(1, c - 5))} style={stepBtn}><Minus size={18} color={colors.ink} /></button>
              <span style={{ ...type.serif, fontSize: 22, color: colors.ink, minWidth: 40, textAlign: "center" }}>{copies}</span>
              <button data-testid="copies-plus" onClick={() => setCopies((c) => Math.min(200, c + 5))} style={stepBtn}><Plus size={18} color={colors.ink} /></button>
            </div>
          </div>
          <button data-testid="generate-pdf-button" onClick={open} style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: spacing.sm, background: colors.accent, height: 56, width: "100%", border: "none", borderRadius: radius.md, color: colors.onAccent, ...type.sansSemi, fontSize: 17, marginTop: spacing.sm }}><Download size={18} color={colors.onAccent} />Genera PDF</button>
          <div style={{ ...type.sans, fontSize: 13, color: colors.inkSoft, textAlign: "center" }}>Il PDF si apre nel browser: da lì puoi stamparlo o salvarlo.</div>
        </div>
      </div>
    </div>
  );
}

const plain = { background: "none", border: "none", display: "flex", padding: 0 };
const stepBtn = { width: 44, height: 44, borderRadius: radius.md, background: colors.bg, border: `1px solid ${colors.line}`, display: "flex", alignItems: "center", justifyContent: "center" };
